export const getMarkupStatus = (product: any) => {
  if ((product.markup || 0) < 35) {
      return 'danger'
  }
  if ((product.markup || 0) > 34 && (product.markup || 0) < 50) {
      return 'warning'
  }
  return 'success'
}
